import {useMutation} from '@tanstack/react-query';

import {postHealthScheduledAppointments} from '../../services/postHealthScheduledAppointments';

export const usePostHealthScheduledAppointmentsMutation = () => {
	return useMutation({
		mutationFn: postHealthScheduledAppointments,
	});
};
